import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

const placeholderProps = {animation: 'internet', name: 'api_consumers'}

export const ApiConsumersAdvancedTable = () => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const {items} = useFilterContext()
	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	const rowModalLink = row => `/api_consumers/${row.original.id}`

	return <AdvancedTable data={tableData} rowModalLink={rowModalLink} placeholderProps={placeholderProps} />
}
